// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"55":"b93c0f66","886":"b2120bb4"}[chunkId] + ".chunk.js";
};